import React, { useState, useEffect } from 'react';
import RemoveLastDirectoryPartOf from '../goBackButton';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import { useAPI } from '../../ApiCalls/useAPI';
const { submitEventParticipation } = useAPI();
const EventDetails = (props) => {
    const event = props.location.state;
   
    function timeConverter(UNIX_timestamp) {
        var a = new Date(UNIX_timestamp * 1000);
        var months = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ];
        var year = a.getFullYear();
        var month = months[a.getMonth()];
        var date = a.getDate();
        return date + ' ' + month + ' ' + year;
    }
    function getTime(UNIX_timestamp) {
        var a = new Date(UNIX_timestamp * 1000);
        var hour = a.getHours();
        var min = a.getMinutes();
        var sec = a.getSeconds();
        return hour + ':' + min + ':' + sec;
    }

 
    const [pstatus, setPstatus] = useState('');
    const [responseMessage, setResponseMessage] = useState('');
    // const [attendance, setAttendance] = useState('');

    useEffect(() => {
        if (event.status === '1') {
          setPstatus('Yes');
        //   setAttendance('Yes');
        } else {
          setPstatus('No');
        //   setAttendance('No');
        }
      }, [event.status]);
    
    

      const handleAttendanceChange = async (status) => {
        setPstatus(status);
        try {
            const response = await submitEventParticipation(event.eid, status);
            console.log(response);
            setResponseMessage('Participation status updated successfully.');
        } catch (error) {
            console.error('Error updating participation status:', error);
            setResponseMessage('Failed to update participation status.');
        }
    };


    if (!event) {
        return (
            <div>
                <div
                    className="m-2"
                    style={{ fontSize: '20px', display: 'flex' }}
                >
                    <div className="mr-4">
                        <a
                            href={RemoveLastDirectoryPartOf(
                                window.location.href
                            )}
                            style={{ textDecoration: 'none' }}
                        >
                            <i className="fe fe-arrow-left" />
                        </a>
                    </div>
                    <div>Event Details</div>
                </div>
                <div>No Event Found</div>
            </div>
        );
    } else {
        return (
            <div>
                <div className="container">
                    <div
                        className="m-2"
                        style={{ fontSize: '20px', display: 'flex' }}
                    >
                        <div className="mr-4">
                            <a
                                href={RemoveLastDirectoryPartOf(
                                    window.location.href
                                )}
                                style={{ textDecoration: 'none' }}
                            >
                                <i className="fe fe-arrow-left" />
                            </a>
                        </div>
                        <div>Event Details</div>
                    </div>

                    <div style={{ justifyContent: 'center',display: 'flex'}}>
                        <img
                            className="eventsimg"
                            src={event.eventImage}
                            alt=""
                        />
                    </div>
                    <div>
                        <h4>Event Name: {event.ename}</h4>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <div className="mr-6">
                            <i className="fe fe-calendar"></i>
                            <span className="ml-2" style={{ margin: '5px' }}>
                                {timeConverter(event.eventdate)}
                            </span>
                        </div>
                        <div>
                            <i className="fe fe-map-pin"></i>
                            <span className="ml-2" style={{ margin: '5px' }}>
                                {event.eventPlace}
                            </span>
                        </div>
                    </div>
                    <div>
                        <i className="fe fe-clock"></i>
                        <span className="ml-2" style={{ margin: '5px' }}>
                            {getTime(event.eventdate)}
                        </span>
                    </div>
                    <div className="mt-2">
                        <h4>Event Description:</h4><p> {event.edesc}</p>
                    </div>
                    {event.acceptparticipation === '0'?null:
                    
                    <div className="mt-2">
                    <h4>Will you be attending the event - Yes/No</h4>
                    <div>
                      <button
                        onClick={() => handleAttendanceChange('Yes')}
                        style={{
                          backgroundColor: pstatus === 'Yes' ? 'green' : 'gray',
                          color: 'white',
                          marginRight: '10px',
                        }}
                      >
                        Yes
                      </button>
                      <button
                        onClick={() => handleAttendanceChange('No')}
                        style={{
                          backgroundColor:  pstatus === 'No' ? 'red' : 'gray',
                          color: 'white',
                        }}
                      >
                        No
                      </button>
                    </div>
                    {pstatus && (
                      <div>
                        <p> {responseMessage}</p>
                      </div>
                    )}
                  </div>
                 }
                   
                    {/* <Tabs></Tabs> */}
                </div>
            </div>
        );
    }
};

export default EventDetails;
